import { ExportAllListActions } from '../ExportAllButton';
import React from 'react';
import {
  ListGuesser,
  ShowGuesser,
  CreateGuesser,
  FieldGuesser,
  InputGuesser,
  EditGuesser,
} from '@api-platform/admin';
import {
  DateField,
  ReferenceArrayField,
  AutocompleteArrayInput,
  SingleFieldList,
  TextField,
  TextInput,
} from 'react-admin';
import { ReferenceField, ChipField, ReferenceArrayInput } from 'react-admin';
import { Grid } from '@mui/material';
import { AddressInputs } from '../Inputs/AddressInputs';
import { usePermissions } from 'react-admin';
import { isGranted } from '../../helper/security';
import { getUser } from '../../helper/user';

export const CompanyList = ({ ...props }) => {
  const { permissions } = usePermissions();
  const user = getUser();

  if (!isGranted(permissions, user)) {
    return null;
  }

  return (
    <ListGuesser actions={<ExportAllListActions />} {...props}>
      <FieldGuesser source={'name'} />
      <ReferenceField label="CreatedBy" source="createdBy" reference="users">
        <TextField source="email" />
      </ReferenceField>
      <DateField source={'createdAt'} locales={'de'} showTime />
    </ListGuesser>
  );
};

export const CompanyShow = (props) => (
  <ShowGuesser {...props}>
    <FieldGuesser source={'name'} />
    <FieldGuesser source={'drupalId'} />
    <ReferenceArrayField label="Users" reference="users" source="users">
      <SingleFieldList>
        <ChipField source="email" />
      </SingleFieldList>
    </ReferenceArrayField>
    <ReferenceArrayField label="Cities" reference="cities" source="cities">
      <SingleFieldList>
        <ChipField source="name" />
      </SingleFieldList>
    </ReferenceArrayField>
    <FieldGuesser source={'baseUrl'} />
    <FieldGuesser source={'createdAt'} />
    <FieldGuesser source={'updatedAt'} />
    <ReferenceField label="CreatedBy" source="createdBy" reference="users">
      <TextField source="email" />
    </ReferenceField>
    <ReferenceField label="UpdatedBy" source="updatedBy" reference="users">
      <TextField source="email" />
    </ReferenceField>
  </ShowGuesser>
);

export const CompanyCreate = (props) => (
  <CreateGuesser {...props}>
    <Grid container spacing={4} sx={{ p: 2 }}>
      <Grid item xs={4}>
        <InputGuesser fullWidth source={'name'} />
        <ReferenceArrayInput
          fullWidth
          source="users"
          reference="users"
          label="Users"
        >
          <AutocompleteArrayInput
            fullWidth
            optionText="email"
            filterToQuery={(searchText) => ({ email: searchText })}
          />
        </ReferenceArrayInput>
      </Grid>
      <Grid item xs={4}>
        <AddressInputs />
      </Grid>
    </Grid>
  </CreateGuesser>
);

export const CompanyEdit = (props) => {
  return (
    <EditGuesser {...props}>
      <Grid container spacing={4} sx={{ p: 2 }}>
        <Grid item xs={4}>
          <InputGuesser fullWidth source={'name'} />
          <InputGuesser
            label={'Drupal Base Url'}
            fullWidth
            source={'baseUrl'}
          />
          <ReferenceArrayInput
            fullWidth
            source="users"
            reference="users"
            label="Users"
          >
            <AutocompleteArrayInput
              fullWidth
              optionText="email"
              filterToQuery={(searchText) => ({ email: searchText })}
            />
          </ReferenceArrayInput>
        </Grid>
        <Grid item xs={4}>
          <AddressInputs />
        </Grid>
        <Grid item xs={4}>
          <TextInput
            label={'Username'}
            fullWidth
            source={'restCredentials.username'}
          />
          <TextInput
            label={'Password'}
            fullWidth
            source={'restCredentials.password'}
          />
        </Grid>
      </Grid>
    </EditGuesser>
  );
};
